import React, { useState } from 'react';

const CardsNotFoundList = props => {
  const [showList, setShowList] = useState(true);

  return (
    <div>
      {props.cardsNotFound.length && (
        <div
          className={`flex flex-row justify-between items-center bg-mediumColor p-4 text-white ${
            showList ? 'rounded-t-md' : 'rounded-md'
          }`}
          onClick={e => setShowList(!showList)}>
          <span className="text-lg font-semibold">
            {props.cardsNotFound.length} Carta
            {props.cardsNotFound.length > 1 ? 's' : ''} no encontrada
            {props.cardsNotFound.length > 1 ? 's' : ''}
          </span>
          {showList ? (
            <i className="fas fa-angle-double-up"></i>
          ) : (
            <i className="fas fa-angle-double-down"></i>
          )}
        </div>
      )}
      {showList && (
        <div className="flex flex-col bg-lightColor rounded-b-md p-4">
          {props.cardsNotFound.map(cardNotFound => (
            <h4 className="text-white text-lg font-semibold">{cardNotFound}</h4>
          ))}
        </div>
      )}
    </div>
  );
};

export default CardsNotFoundList;
